import React, { Component } from 'react';

export default class Chat extends Component {
  render () {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 14 14'>
        <g fill='none' fillRule='evenodd' strokeLinecap='round'>
          <g stroke='#000' strokeWidth='.96'>
            <g>
              <path d='M11.49 8.178c-.03-.108.036-.258.099-.366.02-.032.04-.063.063-.093.539-.8.827-1.744.828-2.709C12.489 2.244 10.155 0 7.269 0 4.752 0 2.652 1.713 2.16 3.987c-.074.337-.11.681-.111 1.026 0 2.769 2.244 5.073 5.13 5.073.459 0 1.077-.138 1.416-.231.339-.093.675-.216.762-.249.09-.034.184-.05.279-.051.104 0 .207.02.303.06l1.701.603c.037.016.077.026.117.03.133 0 .24-.107.24-.24-.002-.027-.007-.055-.015-.081l-.492-1.749z' transform='translate(-75 -7) translate(76 8)' />
              <path d='M.554 5.52c-.802 1.441-.728 3.21.192 4.58.069.105.108.186.096.24-.012.054-.358 1.856-.358 1.856-.017.086.014.174.081.23.044.036.099.054.155.054.03 0 .06-.006.087-.018l1.687-.66c.116-.046.245-.044.36.006.568.221 1.196.36 1.824.36.844 0 1.672-.222 2.402-.645' transform='translate(-75 -7) translate(76 8)' />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
